import { useEffect } from "react";
import Scroll from "react-scroll";
import { isBrowser } from "./is-browser";

export const useScrollToUrlHash = () => {
  useEffect(() => {
    if (!isBrowser()) {
      return;
    }
    if (window.location.hash) {
      setTimeout(() => {
        Scroll.scroller.scrollTo(window.location.hash.split("#")[1], {
          duration: 500,
          smooth: true,
        });
      }, 500);
    }
  }, []);
};
